import React from "react";
import "./styles.scss";

const Index = (props) => (
  <>
    <div
      className={`menu-button-wrapper ${props.type} ${props.size} ${
        props.isActive ? "active" : ""
      } `}
      onClick={props.onClick}
    >
      <div className="mbw-content">{props.content}</div>
    </div>
  </>
);
export default Index;
